interface IImageRendererProps {
	imagePath: string;
	maxWidth?: number;
}

export default function ImageRenderer({
	imagePath,
	maxWidth,
}: IImageRendererProps) {
	return (
		<img
			alt={''}
			src={imagePath}
			title={''}
			style={{ maxWidth: maxWidth ? maxWidth : 1000, margin: 'auto', display: 'flex' }}
		/>
	);
}

